/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PasswordInputs */

const en_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const es_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña`)
};

const fr_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe`)
};

const de_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

const ja_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワード`)
};

const zh_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码`)
};

const ar_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كلمة المرور`)
};

const id_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata Sandi`)
};

const it_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const ru_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароль`)
};

const pt_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha`)
};

const ko_password = /** @type {(inputs: PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const password = /** @type {((inputs?: PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_password(inputs)
	if (locale === "es") return es_password(inputs)
	if (locale === "fr") return fr_password(inputs)
	if (locale === "de") return de_password(inputs)
	if (locale === "ja") return ja_password(inputs)
	if (locale === "zh") return zh_password(inputs)
	if (locale === "ar") return ar_password(inputs)
	if (locale === "id") return id_password(inputs)
	if (locale === "it") return it_password(inputs)
	if (locale === "ru") return ru_password(inputs)
	if (locale === "pt") return pt_password(inputs)
	return ko_password(inputs)
});